function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("title", null, "191115_VF_Icon_calendar_NDN"), /*#__PURE__*/React.createElement("path", {
  d: "M212.5 14.5V7.3h-28.1v7.2H99.1V7.3H71v7.2H0v269h283.5v-269h-71zm42.8 241H28.1V106.7h227.2v148.8zm0-177.7H28.1V42.6H71v14.3h28.1V42.6h85.4v14.3h28.1V42.6h42.8v35.2h-.1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M103.7 156.9l-25.9 9.8v-22.8l37.8-15h15.6v105h-27.5v-77zM178.1 156.9l-25.9 9.8v-22.8l37.8-15h15.6v105h-27.5v-77z"
})));